export const getSupervisorName = (userList: any[], userId: any) => {
  // to avoid issue on refresh from browser on query result page
  if (userList && userList.length > 0) {
    let response: any = userList?.filter((user) => user.value === userId);
    return response.length > 0 && response[0].label ? response[0].label : "";
  }
};

export const removeDiacritics = (str: string): string => {
  return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : "";
};
